export const SET_USER_DATA = '@@USER_MANAGEMENT/SET_USER_DATA';
export const REMOVE_USER_DATA = '@@USER_MANAGEMENT/REMOVE_USER_DATA';
export const SET_USER_PERMISSION = '@@USER_MANAGEMENT/SET_USER_PERMISSION';
export const SET_USER_PREFERENCE = '@@USER_MANAGEMENT/SET_USER_PREFERENCE';
